<template>
  <div class="placeme dropdown">
       <b-button variant="cart-button"
        aria-haspopup="true"
        class="img-icon img-icon-cart-full nav-link pr-0"
        data-toggle="dropdown" v-if="cartItems.length > 0">
        <b-badge variant="light" class="badge-sm badge-floating border-white badge-danger">{{ cartItems.length }}</b-badge>
      </b-button>
      <b-button variant="cart-button"
        aria-haspopup="true"
        class="img-icon img-icon-shopping-cart-2 nav-link pr-0"
        data-toggle="dropdown" v-else>
      </b-button>

    <div class="dropdown-menu dropdown-menu-right width320 list-group" @click.stop.prevent>
      <div class="dropdown-header noti-title">
        <h6 class="text-overflow m-0">Data Manifest Overview <b-button v-b-popover.hover.bottom="'Clear All Items'" @click="$store.dispatch('datacart/resetCart')"
                                                                       variant="outline-primary" size="sm" class="placeRight" v-if="cartItems.length > 0">clear all</b-button></h6>
      </div>
      <div v-for="item in $store.getters['datacart/cartItems']" :key="item.name" class="dropdown-item height100">
        <entity-list-group-item :entity="item"></entity-list-group-item>
      </div>
      <div v-if="cartItems.length === 0" class="text-center p-3">
        No items in the cart.
      </div>
      <div class="dropdown-item" v-if="cartItems.length > 0">
        <router-link :disabled="$store.getters['datacart/cartItems'].length === 0"  to="/manifest-review" class="btn btn-create">Create Data Manifest</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import EntityListGroupItem from '#/ui/Components/Entities/EntityListGroupItem.vue';

export default {
  components: { EntityListGroupItem },
  data() {
    return {
      cartItems: [],
    };
  },
  updated() {
    this.cartItems = this.$store.getters['datacart/cartItems'];
  },
};
</script>

<style scoped>
.width320 {
  width: 500px;
}
.btn-create {
  width: 464px;
}
.cart-button {
  background-color: #5378b1 !important;
  border-color: #5378b1 !important;
}
.badge {
  padding: 0.15rem 0.150rem;
  background-color: rgb(133, 243, 247);
}
.badge-floating {
  position: absolute;
  top: -70%;
  transform: translateY(50%);
  border: 2px solid;
  right: -17px;
}
.placeRight {
  position: fixed;
  right: 22px;
  top: 8px;
}
</style>
